import { SiteHeader } from "./SiteHeader";

export function PageHero({
  label,
  title,
  paragraph = "adaptED builds safe, learning-first AI technology for South African high school learners.",
  quote,
  quoteSource,
  quoteNote,
}: {
  label?: string;
  title: string;
  paragraph?: string;
  quote?: string;
  quoteSource?: string;
  quoteNote?: string;
}) {
  return (
    <section className="surface-ink relative overflow-hidden pb-20 pt-36">
      <SiteHeader />
      <div className="mx-auto max-w-3xl px-6 text-center">
        {label ? <span className="label-rule text-ink-foreground/75">{label}</span> : null}
        <h1 className="mt-4 font-display text-4xl leading-[1.02] text-ink-foreground sm:text-5xl md:text-6xl">
          {title}
        </h1>
        <p className="mx-auto mt-5 max-w-xl text-base text-ink-foreground/80">{paragraph}</p>
        {quote ? (
          <figure className="mx-auto mt-10 flex max-w-2xl flex-col items-center gap-4 rounded-2xl bg-background/95 px-6 py-4 text-center shadow-[var(--shadow-card)]">
            <div>
              <blockquote className="font-display text-base italic text-foreground sm:text-lg">
                “{quote}”
              </blockquote>
              <figcaption className="mt-1 text-xs text-muted-foreground">
                {quoteSource}
                {quoteNote ? (
                  <>
                    {" · "}
                    <span className="text-primary-strong">{quoteNote}</span>
                  </>
                ) : null}
              </figcaption>
            </div>
          </figure>
        ) : null}
      </div>
    </section>
  );
}
